import React from 'react';

import { Product } from 'types/Product';
import { formatSize } from 'utils';
import styles from './ProductSizes.module.css';

export interface ProductSizesProps {
  product: Product;
}

/** A simple ProductCard that can behave as a link or button  */
const ProductSizes: React.FCWithChildren<ProductSizesProps> = ({ product }) => {
  const { height, width, depth, diameter, seat_height, arm_height } = product;

  const measurements = [
    ['H', height],
    ['W', width],
    ['D', depth],
    ['Dia', diameter], // change to ø?
    ['Seat height', seat_height, false],
    ['Arm height', arm_height, false],
  ].filter(([, value]) => typeof value === 'number') as [string, number, boolean | undefined][];

  return (
    <>
      <table className={styles.sizesDesktop}>
        <tbody>
          {measurements.map(([label, value]) => (
            <tr key={label}>
              <td>{label}</td>
              <td>{formatSize(value)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className={styles.sizesMobile}>
        {measurements.map(([label, value, abbreviated = true]) => (
          <div key={label}>
            {label}
            {abbreviated ? '.' : null} {formatSize(value)}
          </div>
        ))}
      </div>
    </>
  );
};

export default ProductSizes;
